import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "@websential/cosmic-v20";
import {
  IYearDDLModel,
  IYearListModel,
  IYearRequestPayload,
  IYearResponsePayload,
} from "../models/Year";

import { IGetListRequest } from "../models";
import http from "../common/http-commons";

// TODO: replace this with API response once it's ready
export const YearService = {
  // create: async (requestPayload: IYearRequestPayload): Promise<IYearResponsePayload> => {
  //   let response: IYearResponsePayload;
  //   return new Promise(resolve => setTimeout(() => resolve(response), 1000));
  // },
  create: async (
    requestPayload: IYearRequestPayload,
  ): Promise<IYearResponsePayload | IServerError | IResponse> => {
    if (requestPayload.id) {
      const response: AxiosResponse<IYearResponsePayload> =
        await http.put<IYearResponsePayload>(
          `/v1/tax-year/${requestPayload.id}/`,
          requestPayload,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
    }

    const response: AxiosResponse<IYearResponsePayload> =
      await http.post<IYearResponsePayload>("/v1/tax-year/", requestPayload);

    if (response.status === 201) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  delYear: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    const response: AxiosResponse<string> = await http.delete<string>(
      `/v1/tax-year/${requestPayload.taxYearId}/`,
    );

    if (response.status === 204) {
      return "Year has been deleted successfully";
    } else if (response.status === 200) {
      return "Year has been deleted successfully";
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    } else if (response.status === 200) {
      return "Year has been deleted successfully";
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  getListDDL: async (): Promise<IYearDDLModel> => {
    const fixedResponse: IYearDDLModel = {
      items: [
        {
          id: "ab8ccece-16c1-44e9-ba86-2990eefb178c",
          year: 2021,
        },
        {
          id: "4e3823aa-c2e4-45aa-aaaf-9ba1b1486acc",
          year: 2022,
        },
      ],
    };
    return new Promise((resolve) =>
      setTimeout(() => resolve(fixedResponse), 1000),
    );

    // const response: AxiosResponse<IYearDDLModel> = await http.get<IYearDDLModel>(
    //   `/v1/data-roles/?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);

    // if (response.status === 200) {
    //   return response.data;
    // } else if (response.status === 400) {
    //   return {
    //     status: false,
    //     message: "Bad Request.",
    //     error: true,
    //   };
    // } else if (response.status === 500) {
    //   return {
    //     status: false,
    //     message: "Something went wrong.",
    //     error: true,
    //   };
    // }

    // return {
    //   status: false,
    //   message: "Something went wrong please try again later.",
    // };
  },
  getList: async (
    params: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<IYearListModel | IServerError | IResponse | any> => {
    // const fixedResponse: IYearListModel = {
    //   "page": 1,
    //   "size": 5,
    //   "total": 2,
    //   "items": [
    //     {
    //       "id": "ab8ccece-16c1-44e9-ba86-2990eefb178c",
    //       "year": 2021,
    //     },
    //     {
    //       "id": "4e3823aa-c2e4-45aa-aaaf-9ba1b1486acc",
    //       "year": 2022,
    //     }
    //   ],
    //   "keyField": {
    //     "field": "id",
    //     "templateUrl": "/years/setup/id"
    //   },
    //   "headerColumns": [
    //     {
    //       "field": "year",
    //       "headerName": "Year",
    //       "description": " Year",
    //       "flex": 1,
    //       "hide": false,
    //       "hideable": false,
    //       "sortable": true,
    //       // "sortingOrder": "asc",
    //       "resizable": false,
    //       "type": "string",
    //       "align": "left",
    //       "headerAlign": "left",
    //       "hideSortIcons": false,
    //       "disableColumnMenu": true,
    //       "disableReorder": true,
    //       "disableExport": true,
    //       "maskable": false,
    //       // "isFixed": true,
    //       "sequence": 0
    //     }
    //   ]
    // }
    // return new Promise(resolve => setTimeout(() => resolve(fixedResponse), 1000));
    // {
    try {
      const response: AxiosResponse<IYearListModel> =
        await http.get<IYearListModel>(
          `/v1/tax-year/?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
    // },
  },
  getById: async (
    id: string | undefined,
  ): Promise<IYearListModel | IServerError | IResponse | any> => {
    if (id) {
      const response: AxiosResponse<IYearListModel> =
        await http.get<IYearListModel>(`/v1/tax-year/${id}/`);

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    }

    return null;
  },
  PutTaxYear: async (
    // requestPayload: IYearRequestPayload
    clientId: string,
    taxYear: number | string,
  ): Promise<any | IServerError | IResponse> => {
    const response: AxiosResponse<any> = await http.put<any>(
      `/v1/tax-year/${clientId}/tax-year/?tax_year=${taxYear}`,
    );

    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }
    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getYear: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse> => {
    const response: AxiosResponse<any> = await http.get<any>(
      `/v1/tax-year/${clientId}`,
    );

    if (response.status === 200) {
      return response.data;
    } else if (response.status === 400) {
      return {
        status: false,
        message: "Bad Request.",
        error: true,
      };
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getYearByClientId: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse> => {
    if (!clientId) return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/tax-year/${clientId}/tax-year/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch {}
  },
  archiveTaxYear: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/taxYear/${archivePayload.taxYearId}/`,
      );

      if (response.status === 201) {
        return "TaxYear has been archived successfully";
      } else if (response.status === 200) {
        return "TaxYear has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getTaxYearDDL: async (): Promise<
    any | IServerError | IResponse | null | any
  > => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/tax-year/tax-year-ddl`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
};
